import { ApiService } from '../ApiService';
import { User } from '../../entities/User';

export class UserService {
  public static get(): Promise<User> {
    return ApiService.get<User>('/users/me');
  }
}
